var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dashboard-page-title',{attrs:{"showAddBtn":false,"showFilter":true,"showSearch":true,"showExportation":true}},[_vm._v(_vm._s(_vm.$t('trips.trips')))]),_c('main-table',{attrs:{"fields":_vm.fields,"list_url":'trips/driver'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }